<strong>
  <ng-container *ngIf="filter.filterTemplate.group != 'DEFAULT'">{{ filter.filterTemplate.group | translate }} <i class="fa fa-caret-right"></i> </ng-container> 
  {{ filter.filterTemplate.label | translate }} 
</strong>
<span style="font-style: italic;">{{ 'FILTERS.ADD.' + filter.operator| translate }}</span> 
{{ filter.value }}
